import {apiCall} from './common';

/* Operations */
export const getOperations = async (params) => await apiCall({method:'GET', endpoint:"ops", params: params});
export const updateOperation = async (op_id, action) => await apiCall({method:'POST', endpoint:`ops/${op_id}`, body: {'action': action}});
export const getOperation = async (op_id) => await apiCall({method:'GET', endpoint:`ops/${op_id}`});
export const createOperation = async (op_name, params) => await apiCall({method:'PUT', endpoint:`ops/${op_name}`, body: {'parameters': params}});
export const updateVulnerabilityAssignee = async (op_id, finding_key, assignee_email) => await apiCall({
    method:'PATCH',
    endpoint:`ops/${op_id}/vulnerability-assignee`,
    body: { finding_key, assignee_email }
});
export const createGithubIssuesForFindings = async (op_id, finding_keys) => await apiCall({
    method:'POST',
    endpoint:`ops/${op_id}/github-issues`,
    body: { finding_keys }
});

/* Tasks */
export const getTasks = async (params) => await apiCall({method:'GET', endpoint:"tasks", params: params});
export const getTasksForOp = async (op_id) => await apiCall({method:'GET', endpoint:"tasks/for-op", params: {"operation": op_id}});
export const updateTask = async (task_id, action) => await apiCall({method:'POST', endpoint:`task/${task_id}`, body: {'action': action}});
export const getTask = async (task_id) => await apiCall({method:'GET', endpoint:`task/${task_id}`});

export const apiGetOperationsForRelease = async (release_uuid) => await apiCall({method:'GET', endpoint:`release/operations`, params: {release: release_uuid}});
